var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-tabs',{attrs:{"value":_vm.tabIndex}},[_c('vs-tab',{attrs:{"label":"4.4.4 점검"},on:{"click":function($event){return _vm.moveTab('safety_check_partner_444')}}},[_c('safety-check-partner444-index')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }